import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { gIco } from 'constants/generic';

interface ProposalHtmlGoogleProps {
  serpHotel: any;
}

const ProposalHtmlGoogle: FC<ProposalHtmlGoogleProps> = ({ serpHotel }) => {
  const { t } = useTranslation();
  const hasGoogleContent = !!serpHotel?.reviews || !!serpHotel?.images?.length;

  if (!serpHotel || !hasGoogleContent) return null;

  return (
    <>
      <div className="pr-hotel-div">
        <div className="pr-ta-title"><img src={gIco} alt="" style={{ margin: '0 5px', width: 20, height: 20 }} /> Google</div>
        {!!serpHotel.reviews && (
          <div>
            <div className="pr-ratings-wr pr-break-avoid">
              <div className="pr-ratings">
                <div className="pr-ratings-number">{serpHotel.overallRating}</div>
                <div className="text-light">
                  {serpHotel.reviews} {t('proposal.reviews')}
                </div>
              </div>
              <div className="pr-ratings-list">
                {serpHotel.ratings.map((rat: any, index: number) => (
                  <div key={index} className="pr-ratings-row-wr">
                    <div className="pr-ratings-star text-sm">
                      {rat.stars} {t('hotel.stars')}
                    </div>
                    <div className="pr-ratings-row">
                      <div
                        className="pr-ratings-row-yellow"
                        style={{
                          width: (rat.count / serpHotel.reviews) * 100 + '%',
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="pr-ratings-breakdown">
              {serpHotel.reviewsBreakdown
                ?.sort(
                  (a: any, b: any) =>
                    b.positive / b.totalMentioned -
                    b.negative / b.totalMentioned -
                    (a.positive / a.totalMentioned - a.negative / a.totalMentioned)
                )
                .map((rew: any, index: number) => (
                  <div className="pr-ratings-breakdown-item" key={index}>
                    <span>
                      {rew.positive / rew.totalMentioned - rew.negative / rew.totalMentioned >
                        0.42 && (
                          <FontAwesomeIcon
                            icon={faThumbsUp}
                            style={{ color: 'green', marginInlineEnd: '5px' }}
                          />
                        )}
                      {rew.positive / rew.totalMentioned - rew.negative / rew.totalMentioned <
                        -0.42 && (
                          <FontAwesomeIcon
                            icon={faThumbsDown}
                            style={{ color: 'red', marginInlineEnd: '5px' }}
                          />
                        )}
                      {rew.name} <span className="text-light">({rew.totalMentioned}) </span>
                    </span>
                  </div>
                ))}
            </div>
          </div>
        )}
        {!!serpHotel.images?.length && (
          <div className="pr-break-avoid">
            <div className="pr-hotel-title">{t('proposal.google_images')}</div>
            <div className="pr-google-images">
              {serpHotel.images.map((img: any, index: number) => (
                <div className="pr-google-image" key={index}>
                  <img
                    src={img.originalImage}
                    alt=""
                    onError={(e) => {
                      (e.target as any).parentNode.style.display = 'none';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProposalHtmlGoogle;
